module.exports = __webpack_public_path__ + "static/media/adam.5aaedf20.jpeg";